import { createSavedSearch } from "@aviv-saved-search/shared/Utils";
import { useConfig } from "@/contexts/cdpConfig";
import { useFeatureEnabled } from "@/hooks/useFeatureEnabled";
import { mapQuerystringToSearchModel } from "@aviv-search/transformers";
import { getShortBrandType } from "@/utils/getShortBrandType";
import { useAuthContext } from "@/contexts/auth";
import { useEffect, useState } from "react";
export const useSendSavedSearchOptIn = () => {
    const CDP_PAGE_SAVED_SEARCH = "lead";
    const { env: stage, locale, brand } = useConfig();
    const { validToken } = useAuthContext();
    const [search, setSearch] = useState(null);
    useEffect(() => {
        if (typeof window !== "undefined") {
            const searchParam = new URL(window.location.href).searchParams.get("search");
            setSearch(searchParam);
        }
    }, []);
    const searchModel = mapQuerystringToSearchModel(search);
    const isSaveSearchOptInEnabled = useFeatureEnabled("savedSearchOptIn") && search;
    const handleSavedSearchOptIn = async (data) => {
        if (!isSaveSearchOptInEnabled || data.newsletterOptout)
            return;
        const email = data.email;
        try {
            const response = await createSavedSearch({
                searchModel,
                page: CDP_PAGE_SAVED_SEARCH,
                stage,
                brand: getShortBrandType(brand),
                locale,
                email,
                oauthToken: validToken !== null && validToken !== void 0 ? validToken : undefined,
            });
            if ("error" in response) {
                console.error("Error response", response.error);
            }
            return response;
        }
        catch (error) {
            console.error("Error saving search", error);
        }
    };
    return {
        handleSavedSearchOptIn,
    };
};
